import { render, staticRenderFns } from "./yuList.vue?vue&type=template&id=84828358&scoped=true"
import script from "./yuList.vue?vue&type=script&lang=js"
export * from "./yuList.vue?vue&type=script&lang=js"
import style0 from "./yuList.vue?vue&type=style&index=0&id=84828358&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84828358",
  null
  
)

export default component.exports